module.exports = __webpack_public_path__ + "img/splash-platform-certificate.26068ac.png";